module.exports = __webpack_public_path__ + "img/fried-plantains.c45b0880.webp";